var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-json"},[_c('input-code-editor',{attrs:{"config":_vm.config,"disabled":_vm.disabled,"readOnly":_vm.readOnly,"focusOnMount":_vm.focusOnMount,"language":"shell"},model:{value:(_vm.rows),callback:function ($$v) {_vm.rows=$$v},expression:"rows"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }